import currencyService from '../services/currency.service'

const dummyCurrency = {
  id: '',
  symbol: '',
  decimals: 2
};

const handlers = {
  currencies: {
    set: 'currencies_set'
  }
}

const initVuexState = function(state) {
  state.currencies = [];
}

const initGetters = function(getters) {
  getters.currencies = (state => state.currencies);
}

const initActions = function(actions) {
  actions[handlers.currencies.set] = ({ commit }, currencies) => commit(handlers.currencies.set, currencies);
}

const initMutations = function(mutations) {
  mutations[handlers.currencies.set] = (state, currencies) => state.currencies = currencies;
}

let currenciesPromise = null;

const initAppState = function(appState, store) {
  appState.currencies = {
    get: () => store.getters.currencies,
    getCurrency: currencyId => store.getters.currencies.filter(c => c.id === currencyId)[0] || dummyCurrency,
    ensure: () => {
      if (!currenciesPromise) {
        currenciesPromise = currencyService.getAll();
        currenciesPromise.then(currencies => {
          store.dispatch(handlers.currencies.set, currencies);
        });
      }
      return currenciesPromise;
    }
  }
}

export default {
  initVuex(vuexState, getters, actions, mutations) {
    initVuexState(vuexState);
    initGetters(getters);
    initActions(actions);
    initMutations(mutations);
  },
  initAppState(appState, store) {
    initAppState(appState, store);
  }
}



// WEBPACK FOOTER //
// ./_common/data/currencies.js